const Sticky = {
    bindEvents: () => {

        // Sélectionne l'élément du header
        const header = document.querySelector('.site-header');

        // Fonction pour ajouter la classe CSS au header
        function addStickyClass() {
        header.classList.add('sticky-border');
        }

        // Fonction pour supprimer la classe CSS du header
        function removeStickyClass() {
        header.classList.remove('sticky-border');
        }

        // Écouteur d'événement pour détecter le scroll de la page
        window.addEventListener('scroll', () => {
        // Vérifie si la position de défilement est supérieure ou égale à 1 pixel
        if (window.scrollY >= 10) {
            addStickyClass();
        } else {
            removeStickyClass();
        }
        });

    }

}

export default Sticky;